import { VIEWS_TYPE_COLOR, ViewsTypes } from "../utils";
import styles from "./styles.module.scss";
import { Tooltip } from "@altimateai/lego";

const ViewsTypeBadge = ({ viewsType }: { viewsType: string }) => (
  <Tooltip title={viewsType}>
    <div
      style={{
        ["--views-color" as string]: VIEWS_TYPE_COLOR[viewsType as ViewsTypes],
      }}
      className={styles.views_type_badge}
    >
      {viewsType[0]}
    </div>
  </Tooltip>
);

export default ViewsTypeBadge;
